import axios from "axios";
import { getToken, httpEvent } from "./utilsApi";

/**
 * District access log (Nov 2026). District admins see their own district; DiscloSure admins pick
 * a district. Downloads from any portal table are recorded with recordExport().
 */
const url = () => `${process.env.REACT_APP_apiBaseUrl}accesslog`;

const fail = (error) => ({
  ok: false,
  message: error?.response?.data?.message || "Couldn't load the access log. Please try again.",
});

export const getAccessLog = async (params) => {
  const token = await getToken();
  try {
    const res = await axios({ method: "GET", url: url(), headers: { "x-api-key": token }, params });
    return { ok: true, ...res.data };
  } catch (error) {
    return fail(error);
  }
};

/** Best-effort: never blocks or breaks a download. */
export const recordExport = async (what, rows) => {
  try {
    const token = await getToken();
    if (!token) return;
    await axios({
      method: "POST",
      url: url(),
      headers: { "x-api-key": token, "Content-Type": "application/json" },
      data: { action: "export", what, rows },
      timeout: 8000,
    });
  } catch (e) {
    /* ignore */
  }
};

export const listDistricts = async () => {
  const res = await httpEvent("crud", "GET", "districts", {});
  const rows = Array.isArray(res?.data?.data) ? res.data.data : Array.isArray(res?.data) ? res.data : [];
  return rows.filter((d) => d && d.id).map((d) => ({ id: d.id, name: d.name || d.id }));
};

export const downloadText = (text, filename) => {
  const blob = new Blob(["﻿" + text], { type: "text/csv;charset=utf-8;" });
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(href);
};
